import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class DebugInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!environment.production) {
            // request = request.clone({
            //     setParams: {
            //         XDEBUG_SESSION_START: '1'
            //     }
            // });
        }
        return next.handle(request);
    }
}
